export enum AssetType
{
    T1100 = 1,
    T1195 = 2
}
